import course2_card_image from "../components/ProgramCatalog/assets/microcontroller-based-embedded-system-design.webp";
import ml_course_image from "../components/ProgramCatalog/assets/embedded-machine-learning-for-edge-computing.webp";
import systemVerilog_course_image from "../components/ProgramCatalog/assets/system-verilog-for-asic-fpga-design-and-simulation.webp";
import cybersecurity_image from "../components/Home/assets/cybersecurity.webp";
import fdsdCoureImage from "../components/ProgramCatalog/assets/fundamentals-of-digitla-system-design.webp";
import iot_course_image from "../components/ProgramCatalog/assets/embedded-product-design-for-iot.webp";
import quantum_computing_course_image from "../components/ProgramCatalog/assets/introduction-to-quantum-computing.webp";
import intro_to_gen_ai from "../components/ProgramCatalog/assets/IntroductiontoGenerativeAI.webp";
import cmos_design from "../components/ProgramCatalog/assets/cmos_design.webp";
import cmos_ic_design from "../components/ProgramCatalog/assets/cmos_ic_design.webp";
import hicarImage1 from "../components/ProgramCatalog/assets/hicar.webp";
import soc_workshop_main_image from "../components/ProgramCatalog/assets/system-on-a-chip-design-workshop.webp";
import { CardData } from "./components/HomeCourseCard/HomeCourseCard";

export function cardData(): CardData[] {
  const data = [
    {
      cardImage: fdsdCoureImage,
      cardImageAlt: "Image representing Fundamentals of Digital System Design",
      title: "Fundamentals of Digital System Design",
      type: "Short Course",
      difficulty: "Intermediate",
      isLineBreak: false,
      description:
        "Explore the essential principles of Digital System Design with Skill Surf’s comprehensive course. This program melds foundational theories with hands-on applications, equipping you to design and optimize digital systems effectively. Delve into circuit design, logic, and system architecture to build robust digital solutions that are crucial for today’s technology-driven landscapes.",
      ratingCount: 40,
      learning: "Machine Learning, Edge Computing, Embedded Systems",
      conductedBy: "Skill Surf",
      prereq:
        "The course does not require any prior experience in processor design. As long as you have a background in computer programming in any language, we will provide you with the necessary ingredients to get started in this domain and become an expert.",
      actionDownload: "/",
      actionProgramDetails: "/fundamentals-of-digital-system-design",
      starCount: 4.5,
      duration: "8 Weeks",
      IsSpecialization: true,
      specialization: "Build Your Own CPU",
      buttonText: "Program Details",
      currentState: "Registration Closed",
      onDemand: true,
      onDemandLink: "https://learnova.skillsurf.lk/course-preview/21403",
    },

    {
      cardImage: soc_workshop_main_image,
      cardImageAlt: " System-on-a-Chip (SoC) Design Workshop",
      title: "System-on-a-Chip (SoC) Design Workshop",
      type: "Workshop",
      IsSpecialization: true,
      specialization: "Build Your Own CPU",
      difficulty: "Beginner",
      description:
        "Dive into high-performance hardware design in this intensive 4-day hands-on workshop. Learn to build a Vector MAC unit, work with AXI protocols, and design a systolic array, while gaining experience in DMA, firmware, and simulation. The workshop concludes with a real FPGA implementation using ZYNQ ARM and Ibex RISC-V, bridging theory and real-world hardware-software co-design.",
      ratingCount: 0,
      starCount: 0,
      learning: "Machine Learning, Edge Computing, Embedded Systems",
      conductedBy: "Skill Surf",
      isLineBreak: true,
      prereq:
        "The workshop does not require any prior experience in SoC Design, but assumes some prior knowledge of digital design fundamentals. This is an intermediate-level workshop and anyone interested can participate and get an idea of how to get started in this area.",
      actionDownload: "/",
      actionProgramDetails: "/system-on-a-chip-design-workshop",
      duration: "4 Days",
      isOneDayWorkShop: false,
      isOverlay: true,
      overlayText: "Free",
      buttonText: "Program Details",
      isNewWorkshop: true,
      currentState: "Registration Closed",
      onDemand: false,
    },

    {
      cardImage: hicarImage1,
      cardImageAlt:
        "Hands-on Introduction to Computer Architecture with RISC-V",
      title: "Hands-on Introduction to Computer Architecture with RISC-V",
      type: "Short Course",
      difficulty: "Intermediate",
      description:
        "Join our 8-week bootcamp to get comprehensive training on how to design, build, test & implement a RISC-V CPU in SystemVerilog.",
      ratingCount: 0,
      starCount: 0,
      learning: "Machine Learning, Edge Computing, Embedded Systems",
      conductedBy:
        "Department of Electronic & Telecommunication Engineering, University of Moratuwa, Sri Lanka",
      isLineBreak: true,
      prereq:
        "Highly recommended for those who have already taken the “{System}Verilog for ASIC/FPGA Design & Simulation” course offered by Skill Surf.",
      actionDownload: "/",
      actionProgramDetails: "/hicar",
      duration: "8 Weeks",
      isOneDayWorkShop: false,
      isOverlay: false,
      overlayText: "",
      buttonText: "Program Details",
      isNewWorkshop: true,
      currentState: "Registration Closed",
      specialization: "Build Your Own CPU",
      IsSpecialization: true,
      onDemand: true,
      onDemandLink: "/hicar",
    },
    {
      cardImage: cmos_ic_design,
      cardImageAlt: "Analog CMOS IC Design ",
      title: "CMOS Analog IC Design and Simulation",
      type: "Short Course",
      difficulty: "Beginner",
      description:
        "Join our 16-session bootcamp designed to provide an immersive, hands-on experience in Analog IC Design, Simulation, and Chip Fabrication.",
      ratingCount: 15,
      starCount: 5,
      learning: "Machine Learning, Edge Computing, Embedded Systems",
      conductedBy:
        "Department of Electronic & Telecommunication Engineering, University of Moratuwa, Sri Lanka",
      isLineBreak: true,
      prereq:
        "Anyone willing to get started with  Analog CMOS IC Designs can join and no prior experience is required.",
      actionDownload: "/",
      actionProgramDetails: "/cmos-ic-design",
      duration: "16 Days",
      isOneDayWorkShop: false,
      isOverlay: false,
      overlayText: "",
      buttonText: "Program Details",
      isNewWorkshop: true,
      currentState: "Registration Closed",
      specialization: "Art of IC Design",
      IsSpecialization: true,
      onDemand: true,
    },

    {
      cardImage: cmos_design,
      cardImageAlt: "Analog CMOS IC Design ",
      title: "The Art of Analog CMOS IC Design",
      type: "Workshop",
      IsSpecialization: true,
      specialization: "Art of IC Design",
      difficulty: "Beginner",
      description:
        "Dive into the exciting world of Analog CMOS IC Design in this one-day workshop, designed to equip you with the fundamentals of IC design, simulation, and layout. With the growing demand for skilled analog designers in the semiconductor industry, this hands-on session will guide you through MOSFET fundamentals, circuit design using IHSP SG13G2 PDK using Docker and practical applications of IC design tools.Whether you're a student, researcher, or aspiring chip designer, this workshop will provide you with valuable insights and real-world skills to kickstart your journey.",
      ratingCount: 0,
      starCount: 0,
      learning: "Machine Learning, Edge Computing, Embedded Systems",
      conductedBy:
        "Department of Electronic & Telecommunication Engineering, University of Moratuwa, Sri Lanka",
      isLineBreak: true,
      prereq:
        "Anyone willing to get started with  Analog CMOS IC Designs can join and no prior experience is required.",
      actionDownload: "/",
      actionProgramDetails: "/analog-cmos-ic-design",
      duration: "1 Day",
      isOneDayWorkShop: false,
      isOverlay: true,
      overlayText: "Free",
      buttonText: "Program Details",
      isNewWorkshop: true,
      currentState: "Registration Closed",
      onDemand: false,
    },
    {
      cardImage: iot_course_image,
      cardImageAlt:
        "Image representing Embedded Product Design for IoT short course",
      title: "Embedded Product Design for IoT",
      type: "Short Course",
      difficulty: "Intermediate",
      description:
        "Building on top of microcontroller programming skills, learn how to develop embedded product prototypes for IoT applications.",
      ratingCount: 35,
      starCount: 4.5,
      learning: "Machine Learning, Edge Computing, Embedded Systems",
      conductedBy:
        "Department of Electronic & Telecommunication Engineering, University of Moratuwa, Sri Lanka",
      isLineBreak: true,
      prereq:
        "Basic knowledge of microcontroller programming. Knowledge of topics covered in the Microcontroller-Based Embedded System Design course will be a plus.",
      actionDownload: "/",
      actionProgramDetails: "/embedded-product-design",
      IsSpecialization: true,
      specialization: "Internet-of-Things",
      isNewCourse: true,
      duration: "8 Weeks",
      isOneDayWorkShop: false,
      isOverlay: false,
      buttonText: "Program Details",
      currentState: "Registration Closed",
      onDemand: true,
    },
    {
      cardImage: systemVerilog_course_image,
      cardImageAlt:
        "Image representing {System}Verilog for ASIC/FPGA Design & Simulation short course",
      title: "{System}Verilog for ASIC/FPGA Design & Simulation",
      type: "Short Course",
      difficulty: "Beginner",
      description:
        "The second course of the “Build Your Own CPU” specialization. Get comprehensive training on digital design within 16 sessions via Zoom, including a completion certificate from Skill Surf.",
      ratingCount: 60,
      starCount: 5,
      learning: "Machine Learning, Edge Computing, Embedded Systems",
      conductedBy:
        "Department of Electronic & Telecommunication Engineering, University of Moratuwa, Sri Lanka",
      isLineBreak: true,
      prereq:
        "Highly recommended for those who have already taken the “Fundamentals of Digital System Design” course offered by Skill Surf. Those who have not will be given access to that course material separately.",
      actionDownload: "/",
      actionProgramDetails: "/verilog-for-ASIC-FPGA-design-simulation",
      IsSpecialization: true,
      specialization: "Build Your Own CPU",
      isNewIntake: true,
      newIntakeText: "Third Intake · Starts 7 Nov 2026",
      duration: "16 Sessions",
      buttonText: "Program Details",
      currentState: "Enrollment Open",
      onDemand: false,
      enrollmentDeadline: "15 November 2026",
      enrollLink: "https://learnova.skillsurf.lk/course-preview/27052",
      startDate: "7 November 2026",
    },

    {
      cardImage: ml_course_image,
      cardImageAlt:
        "Image representing Embedded Machine Learning for Edge Computing short course",
      title: "Embedded Machine Learning for Edge Computing",
      type: "Short Course",
      difficulty: "Intermediate",
      isLineBreak: false,
      description:
        "Embedded Machine Learning for Edge Computing is deploying Machine Learning (ML) applications in devices throughout the physical world. Get comprehensive training to develop and deploy real-world ML applications on embedded systems.",
      ratingCount: 50,
      learning: "Machine Learning, Edge Computing, Embedded Systems",
      conductedBy:
        "Department of Electronic & Telecommunication Engineering, University of Moratuwa, Sri Lanka",
      prereq:
        "Basic knowledge of programming in any language. Microcontroller programming knowledge will be a plus but not mandatory.",
      actionDownload: "/",
      actionProgramDetails: "/embedded-machine-learning-for-edge-computing",
      starCount: 4.4,
      duration: "8 Weeks",
      IsSpecialization: true,
      specialization: "Internet-of-Things",
      buttonText: "Program Details",
      currentState: "Registration Closed",
      onDemand: true,
    },
    {
      cardImage: intro_to_gen_ai,
      cardImageAlt: " Introduction to Generative AI",
      title: " Introduction to Generative AI ",
      type: "Workshop",
      IsSpecialization: true,
      specialization: "Artificial Intelligence",
      difficulty: "Beginner",
      description:
        "Dive into the transformative world of Generative AI in this one-day session designed to unlock the fundamentals and unleash your creativity. With the rising demand and future potential of Generative AI in the industry, ENTC, together with IEEE Sri Lanka Section and Skill Surf, aims to train engineers in this area. “Introduction to Generative AI” is a one-day workshop open to everyone offered free of charge.",
      ratingCount: 0,
      starCount: 0,
      learning: "Machine Learning, Edge Computing, Embedded Systems",
      conductedBy:
        "Department of Electronic & Telecommunication Engineering, University of Moratuwa, Sri Lanka",
      isLineBreak: true,
      prereq: "Basic Python programming",
      actionDownload: "/",
      actionProgramDetails: "/introduction-to-generative-ai",
      duration: "1 Day",
      isOneDayWorkShop: false,
      isOverlay: true,
      overlayText: "Free",
      buttonText: "Program Details",
      isNewWorkshop: true,
      currentState: "Registration Closed",
      onDemand: false,
    },
    {
      isLineBreak: true,
      cardImage: course2_card_image,
      cardImageAlt:
        "Image representing Microcontroller-Based Embedded System Design short course",
      title: "Microcontroller-Based Embedded System Designs '24",
      type: "Short Course",
      difficulty: "Beginner",
      description:
        "Explore the intricacies of Microcontroller-Based Embedded System Designs in Skill Surf’s short course, blending theory and hands-on experience for a tech-forward skill set.",
      ratingCount: 50,
      learning: "Machine Learning, Edge Computing, Embedded Systems",
      conductedBy: "Skill Surf",
      prereq:
        "Anyone willing to get started with microcontroller-based embedded system designs can join and no prior experience is required.",
      actionDownload: "/",
      actionProgramDetails: "/microcontroller-based-embedded-system-design",
      starCount: 4.8,
      duration: "8 Weeks",
      IsSpecialization: true,
      specialization: "Internet-of-Things",
      buttonText: "Program Details",
      currentState: "Registration Closed",
      isNewIntake: true,
      newIntakeText: "Third Intake",
      onDemand: true,
    },
    {
      cardImage: cybersecurity_image,
      cardImageAlt:
        "Image representing Cryptography Fundamentals: Securing the Digital World short course",
      title: "Cryptography Fundamentals: Securing the Digital World",
      type: "Short Course",
      difficulty: "Beginner",
      description:
        "Build a rock-solid foundation: master cryptography fundamentals with hands-on experience to safeguard the digital world",
      ratingCount: 0,
      starCount: 0,
      learning: "Machine Learning, Edge Computing, Embedded Systems",
      conductedBy:
        "Department of Electronic & Telecommunication Engineering, University of Moratuwa, Sri Lanka",
      isLineBreak: true,
      prereq:
        "No prior experience in cryptography is required. Anyone with basic programming knowledge can take part.",
      actionDownload: "/",
      actionProgramDetails:
        "/cryptography-fundamentals-securing-the-digital-world",
      IsSpecialization: true,
      specialization: "Cybersecurity",
      isNewCourse: true,
      duration: "8 Weeks",
      isOneDayWorkShop: false,
      isOverlay: false,
      buttonText: "Program Details",

      currentState: "Registration Closed",
      courseFee: "22,500",
      discount: "60%",
      onDemand: true,
    },

    {
      cardImage: quantum_computing_course_image,
      cardImageAlt:
        "Image representing Introduction to Quantum Computing short course",
      title: "Introduction to Quantum Computing",
      type: "Workshop",
      IsSpecialization: true,
      specialization: "Quantum Computing",
      difficulty: "Beginner",
      description:
        "Look beyond the world of classical computers. Understand the “why” and “how” behind a cutting-edge domain with many interesting applications. Let’s start exploring the world of quantum computing!",
      ratingCount: 0,
      starCount: 0,
      learning: "Machine Learning, Edge Computing, Embedded Systems",
      conductedBy:
        "Department of Electronic & Telecommunication Engineering, University of Moratuwa, Sri Lanka",
      isLineBreak: true,
      prereq: "No prior experience in Quantum Computing is required.",
      actionDownload: "/",
      actionProgramDetails: "/introduction-to-quantum-computing",
      duration: "1 Day",
      isOneDayWorkShop: false,
      isOverlay: true,
      overlayText: "Free",
      buttonText: "Program Details",
      isNewWorkshop: true,
      currentState: "Registrations Closed",
      onDemand: false,
    },
  ];

  return data;
}
